import { Link } from "react-router-dom";

interface RangeItem {
  label: string;
  range: string;
  desc: string;
  count: number;
  icon: string;
}

const ranges: RangeItem[] = [
  { label: "01–05 集", range: "1-5", desc: "初入陈家的磨合与试探", count: 5, icon: "ri-home-heart-line" },
  { label: "06–10 集", range: "6-10", desc: "误会加深，矛盾集中爆发", count: 5, icon: "ri-emotion-unhappy-line" },
  { label: "11–15 集", range: "11-15", desc: "彼此靠近，隔阂开始融化", count: 5, icon: "ri-hand-heart-line" },
  { label: "16–20 集", range: "16-20", desc: "和解团圆，走向大结局", count: 5, icon: "ri-heart-3-line" },
];

export default function EpisodeRangeCards() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {ranges.map((item) => (
        <Link
          key={item.range}
          to={`/episodes?range=${item.range}`}
          className="group flex items-center gap-4 p-4 md:p-5 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-primary-50/60 transition-colors cursor-pointer"
        >
          <span className="w-12 h-12 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-white transition-colors">
            <i className={`${item.icon} text-2xl`} />
          </span>
          <span className="min-w-0 flex-1">
            <span className="flex items-center justify-between gap-2">
              <span className="font-heading font-semibold text-foreground-950 text-base">
                {item.label}
              </span>
              <span className="text-xs text-foreground-500">{item.count} 集</span>
            </span>
            <span className="block text-sm text-foreground-600 mt-1 truncate">{item.desc}</span>
          </span>
          <i className="ri-arrow-right-s-line text-xl text-foreground-400 group-hover:text-primary-600 group-hover:translate-x-0.5 transition-all" />
        </Link>
      ))}
    </div>
  );
}